import { useQuery } from '@tanstack/react-query';

import { ballotGuideAPI } from '../api/ballot-guide';

export function useDeliveryHistory() {
  return useQuery({
    queryKey: ['delivery-history'],
    queryFn: () => ballotGuideAPI.getDeliveries(),
  });
}
